import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f1cc35a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zone-selection-info" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "headline" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import { marked } from 'marked'


export default /*#__PURE__*/_defineComponent({
  __name: 'CZoneSelectionInfo',
  setup(__props) {

// Info section on top of the zone selection page
function md(text: string) {
  return marked(text)
}

return (_ctx: any,_cache: any) => {
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_header = _resolveComponent("t-header")!
  const _component_t_text = _resolveComponent("t-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_t_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(_component_t_container, null, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require('@/assets/zone-overview/zone_selection_badge.png'),
                class: "badge"
              }, null, 8, _hoisted_3),
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('zoneOverview.main.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_t_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_t_text, { class: "info-layout" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "info-box",
                innerHTML: md(_ctx.$t('zoneSelectionInfo.box1.text'))
              }, null, 8, _hoisted_5),
              _createElementVNode("div", {
                class: "info-box",
                innerHTML: md(_ctx.$t('zoneSelectionInfo.box2.text'))
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "info-box",
                innerHTML: md(_ctx.$t('zoneSelectionInfo.box3.text'))
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})